<template>
  <div>

    <lk-form slot='content' :model='goodsForm' :rules='validate' :label-width='134'
      label-position="right" ref="goodsForm">
      <div class="cardContainer">
        <lk-card title='基础商品信息'>
          <lk-row :gutter="16">
            <lk-col span='7'>
              <lk-form-item label='化学成分:'>
                <lk-input :maxlength='50' clearable placeholder="请输入"
                  v-model.trim="goodsForm.chemicalComposition"></lk-input>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='成分分类:'>
                <lk-input :maxlength='50' clearable placeholder="请输入"
                  v-model.trim="goodsForm.chemistryType"></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <MedicationGuidance
        v-model="goodsForm"
        :showFAQ="false"
        :able='true'
      />
    </lk-form>
  </div>
</template>

<script>
import MedicationGuidance from './MedicationGuidance.vue'; // 用药指导

export default {
  name: 'DrugEdit',
  components: {
    MedicationGuidance,
  },
  props: {
    info: {
      type: Object,
    },
  },
  model: {
    prop: 'info',
    event: 'change',

  },
  watch: {
    info: {
      handler() {
        this.goodsForm = this.info;
      },
    },
  },
  computed: {
  },
  data() {
    return {
      goodsForm: {
      },
      validate: {},
    };
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
</style>
